import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import React from 'react';

import { ExternalLink } from 'client-web-sdk';

import { ReactComponent as CloseIcon } from 'src/images/icons/close.svg';

import styles from './BrowserOutdatedBanner.module.css';

export default function BrowserOutdatedBanner({ onRequestClose }: { onRequestClose?: () => void }) {
  return (
    <aside className={styles.BrowserOutdatedBanner}>
      <strong className={styles.Info}>
        <Trans>Your browser is out of date. Please update your browser to use heylogin.</Trans>
      </strong>
      <ExternalLink href={t`https://browsehappy.com/?locale=en`}>
        <Trans>How to update?</Trans>
      </ExternalLink>{' '}
      {onRequestClose && (
        <button type="button" className={styles.Close} onClick={onRequestClose}>
          <CloseIcon aria-label={t`Close`} />
        </button>
      )}
    </aside>
  );
}
